import { ConnectedSidebar } from "controller/sidebar/connected-sidebar";
import {
  SIDEBAR_DEVICE_DETAIL_KEY,
  SIDEBAR_EDIT_CONTENT_KEY,
} from "fleet/constant/sidebar";
import React from "react";

import { ConnectedSidebarContentEditor } from "./content-editor/connected-sidebar-content-editor";
import { ConnectedDeviceDetails } from "./device-details/connected-device-details";

class FleetSideBar extends React.PureComponent {
  render() {
    return (
      <ConnectedSidebar>
        <ConnectedSidebarContentEditor eventKey={SIDEBAR_EDIT_CONTENT_KEY} />
        <ConnectedDeviceDetails eventKey={SIDEBAR_DEVICE_DETAIL_KEY} />
      </ConnectedSidebar>
    );
  }
}

export { FleetSideBar };
